import React from "react";

const Day = () => {
  return <>Day</>;
};
export default Day;
